<template>
    <div class="c-contactForm">
        <div class="c-contactForm__textarea">
            <h4 class="text-center">Masz dodatkowe informacje? Napisz nam o tym.</h4>
            <label class="c-contactForm__textareaInput">
                <p>Dodatkowe informacje:</p>
                <textarea v-model="lead.additional_info"></textarea>
            </label>
        </div>
        <h2 class="text-center mt--3">Zostaw nam swoje dane kontaktowe</h2>
        <p class="text-center">Nasz specjalista skontaktuje się z Tobą.</p>
        <div class="c-contactForm__form mt--3">
            <Row>
                <label>
                    <input type="text" placeholder="Imię" v-model="lead.first_name">
                </label>
                <label>
                    <input type="text" placeholder="Nazwisko" v-model="lead.last_name">
                </label>
            </Row>
            <Row>
                <label>
                    <input type="text" placeholder="E-mail" v-model="lead.email">
                </label>
                <label>
                    <input type="text" placeholder="Numer telefonu" v-model="lead.phone">
                </label>
            </Row>
            <Row>
                <label>
                    <input type="text" placeholder="Numer rejestracyjny samochodu" v-model="lead.registration_number">
                </label>
                <label>
                    <input type="text" placeholder="Numer VIN (pole nieobowiązkowe)" v-model="lead.vin">
                </label>
            </Row>
            <div class="c-contactForm__accepts">
                <label class="c-contactForm__checkbox">
                    <input type="checkbox" class="mr--1" v-model="lead.accept1" true-value="TAK" false-value="NIE">
                    <span>Wyrażam zgodę na przetwarzanie moich danych osobowych wskazanych wyżej w celach marketingowych, przez Krotoski Spółka z ograniczoną odpowiedzialnością</span>
                </label>
                <strong class="ml--2 c-contactForm__showBtn" v-bind:class="{'c-contactForm__showBtn--active':acceptsToggle[0]}" v-on:click="acceptsToggle[0] = !acceptsToggle[0]"><img src="@/assets/images/tick.png" alt="<">{{ acceptsToggle[0]?'zwiń całość':'rozwiń całość'}}</strong>
                <p class="ml--2" v-if="acceptsToggle[0]">Podanie moich danych osobowych było dobrowolne i świadome. Poinformowano mnie o przysługujących mi prawach, w szczególności o prawie cofnięcia zgody w każdym czasie, bez wpływu na zgodność z prawem przetwarzania, którego dokonano na podstawie zgody przed jej wycofaniem.</p>
                <label class="c-contactForm__checkbox">
                    <input type="checkbox" class="mr--1" v-model="lead.accept2" true-value="TAK" false-value="NIE">
                    <span>Wyrażam zgodę na marketing telefoniczny.</span>
                </label>
                <strong class="ml--2 c-contactForm__showBtn" v-bind:class="{'c-contactForm__showBtn--active':acceptsToggle[1]}" v-on:click="acceptsToggle[1] = !acceptsToggle[1]"><img src="@/assets/images/tick.png" alt="<">{{ acceptsToggle[1]?'zwiń całość':'rozwiń całość'}}</strong>
                <p class="ml--2" v-if="acceptsToggle[1]">Zgoda wyrażona jest dla Krotoski Spółka z ograniczoną odpowiedzialnością. W ramach zgody możemy przesyłać do Ciebie informacje marketingowe dotyczące działalności naszej firmy.</p>
                <label class="c-contactForm__checkbox">
                    <input type="checkbox" class="mr--1" v-model="lead.accept3" true-value="TAK" false-value="NIE">
                    <span>Wyrażam zgodę na przesyłanie informacji handlowych na e-mail.</span>
                </label>
                <strong class="ml--2 c-contactForm__showBtn" v-bind:class="{'c-contactForm__showBtn--active':acceptsToggle[2]}" v-on:click="acceptsToggle[2] = !acceptsToggle[2]" ><img src="@/assets/images/tick.png" alt="<">{{ acceptsToggle[2]?'zwiń całość':'rozwiń całość'}}</strong>
                <p class="ml--2" v-if="acceptsToggle[2]">Zgoda wyrażona jest dla Krotoski Spółka z ograniczoną odpowiedzialnością. W ramach zgody możemy przesyłać do Ciebie informacje handlowe dotyczące działalności naszej firmy.</p>
                <div class="ml--2">
                    <p>
                        Treść obowiązku informacyjnego RODO:
                    </p>
                    <p>
                        Współadministratorami Państwa danych osobowych zebranych w drodze powyższego formularza są:
                        <br>
                        1. Krotoski Spółka z ograniczoną odpowiedzialnością z siedzibą w Łodzi, przy ul. Niciarnianej 51/53, legitymująca się numerem KRS: 0000946790, (dalej także jako Spółka).
                        Dane kontaktowe Inspektora Ochrony Danych: ul. Niciarniana 51/53, 92-320 Łódź, e-mail: dane.osobowe@krotoski.com, nr tel.: 785 012 459.
                    </p>
                    <strong class="c-contactForm__showBtn" v-bind:class="{'c-contactForm__showBtn--active':acceptsToggle[3]}" v-on:click="acceptsToggle[3] = !acceptsToggle[3]"><img src="@/assets/images/tick.png" alt="<">{{ acceptsToggle[3]?'zwiń całość':'rozwiń całość'}}ć</strong>
                    <span class="ml--2" v-if="acceptsToggle[3]">
                        <p>Dane kontaktowe Inspektora Ochrony Danych: ul. Niciarniana 51/53, 92-320 Łódź, e-mail: dane.osobowe@krotoski.com, nr tel.: 785 012 459.</p>
                        <p>2. Volkswagen Group Polska Sp. z o.o. legitymująca się numerem KRS: 0000327143, adres: ul. Krańcowa 44, 61-037 Poznań. Dane kontaktowe Inspektora Ochrony Danych: e-mail: iod@vw-group.pl lub pisemnie na w/w adres z dopiskiem „IOD”.</p>
                        <p>3. Wskazane wyżej dane osobowe są przetwarzane w celu przygotowania i prezentacji oferty handlowej. W przypadku wyrażenia jednej z wyżej wskazanych zgód marketingowych, dane osobowe przetwarzane będą również w celu przekazywania informacji marketingowych i handlowych.</p>
                        <p>4. Podstawa prawna przetwarzania: przetwarzanie odbywa się w celu podjęcia działań niezbędnych do zawarcia umowy (art. 6 ust. 1 lit. b RODO). W przypadku wyrażenia jednej z powyższych zgód marketingowych przetwarzanie odbywa się w oparciu o Pani/Pana zgodę (art. 6 ust. 1 lit. a RODO). W przypadku przetwarzania danych osobowych w celach dowodowych (ochrona praw i obrona przed roszczeniem), przetwarzanie opiera się o prawnie uzasadniony interes Spółki (art. 6 ust. 1 lit. f RODO).</p>
                        <p>5. Dane osobowe przetwarzane będą do chwili zawarcia oraz realizacji umowy oraz dalej do chwili przedawnienia roszczeń plus 1 rok od tego dnia (do chwili wygaśnięcia prawdopodobieństwa roszczeń) lub do chwili odstąpienia od zamiaru zawarcia umowy. W zakresie wyrażonych zgód marketingowych, dane osobowe będą przetwarzane do momentu odwołania zgody, a dalej przez okres prawdopodobieństwa przedawnienia roszczeń w celach dowodowych.</p>
                        <p>6. Kategorie odbiorców danych osobowych: podmioty wykonujące na rzecz Spółki zadania związane z administrowaniem strony internetowej; podmioty wykonujące na rzecz Spółki zadania związane z administrowaniem systemami teleinformatycznymi, podmioty realizujące dla Spółki określone czynności marketingowe, np. agencja reklamowa, organizator eventu, callcenter, spółki z grupy Volkswagen (Volkswagen Group Polska Sp. z o.o., Volkswagen AG, Dr. Ing. h.c. F. Porsche AG, Porsche Central and Eastern Europe s.r.o., Porsche Smart Mobility GmbH, ).</p>
                        <p>7. Osoba, której dane osobowe są przetwarzane ma prawo dostępu do danych, ich sprostowania, usunięcia, ograniczenia przetwarzania, wniesienia sprzeciwu wobec przetwarzania oraz prawo do przenoszenia danych osobowych, z zastrzeżeniem, że prawo do przenoszenia danych osobowych dotyczy wyłącznie danych przetwarzanych w sposób wyłącznie zautomatyzowany.</p>
                        <p>8. Osoba, której dane osobowe są przetwarzane ma prawo wniesienia skargi do właściwego organu nadzorczego – Prezesa Urzędu Ochrony Danych.</p>
                        <p>9. Podanie danych osobowych jest dobrowolne.</p>
                    </span>
                </div>
            </div>
            <div class="text-center mt--2 mb--2">
                <button v-on:click="submit()">Wyślij</button>
            </div>
        </div>
    </div>
</template>
<script>

import lead from '../mixins/lead.js'

import {mapActions} from 'vuex'

export default {
    data(){
        return{
            acceptsToggle:{
                0:false,
                1:false,
                2:false,
                3:false
            }
        }
    },
    mixins:[lead],
    methods:{
        ...mapActions(['submit'])
    }
}
</script>
<style lang="scss">
    .c-contactForm{
        &__textarea{
            max-width: 906px;
            margin:0 auto;
            padding: 1rem;
            textarea{
                width: 100%;
                min-height: 320px;
                border: 1px solid #000;
                border-radius: 1rem;
                padding: 1rem;
                font-size: 1rem;
                outline: none;
            }
        }
        &__textareaInput{
            border: 1px solid #000;
            border-radius: 1rem;
            padding: 1rem;
        }
        &__form{
            max-width: 962px;
            margin: 0 auto;
        }
        &__accepts{
            font-size: .9rem;
        }
        &__checkbox{
            display: flex;
            span{
                width: 100%;
            }
        }
        &__showBtn{
            cursor: pointer;
            img{
                width: .8rem;
                transform: rotate(-90deg) translateX(13%);
                image-rendering: pixelated;
            }
            &--active{
                img{
                    transform: rotate(0deg);
                }
            }
        }
    }
</style>
